/**
 * Handling the header scroll
 * */

    (function($) {



        var fh = $('#fixed-header');
        $('body').waypoint({
            handler: function(direction){
                if( direction == "up"){
                    fh.removeClass('active');
                }else{
                    fh.addClass('active');
                }
            },
            offset: -200

        })




    })( jQuery );

